export interface AssignedSchemaFacility {
    SchemaID: string;
    Schemas?: string[];
}

export interface AssignedSchemaSummary {
    ID: string;
    Name: string;
}

export function getAssignedSchemaIds(facility: AssignedSchemaFacility): string[] {
    return [...new Set([facility.SchemaID, ...(facility.Schemas ?? [])].filter(Boolean))];
}

export function orderAssignedSchemas<T extends AssignedSchemaSummary>(
    facility: AssignedSchemaFacility,
    schemas?: T[] | null
): T[] {
    const schemaLookup = new Map((schemas ?? []).map(schema => [schema.ID, schema] as const));

    return getAssignedSchemaIds(facility)
        .map(id => schemaLookup.get(id))
        .filter((schema): schema is T => !!schema)
        .sort((left, right) => left.ID === facility.SchemaID
            ? -1
            : right.ID === facility.SchemaID
                ? 1
                : left.Name.localeCompare(right.Name, undefined, { sensitivity: 'base' }));
}
